import { useAtom } from 'jotai';
import { showAmazonManualLoadModalAtom } from 'src/store';
import { ManualCartLoadFlow } from './ManualCartLoadFlow';

type Props = {
  page: 'get' | 'embed';
};

/** Shown for Amazon marketplaces without aws/cart/add (e.g. amazon.ie), where the cart can only be loaded by hand. */
export const AmazonManualLoadModal = ({ page }: Props) => {
  const [show, setShow] = useAtom(showAmazonManualLoadModalAtom);

  return (
    <ManualCartLoadFlow
      open={show}
      onClose={() => setShow(false)}
      page={page === 'embed' ? 'Embed' : 'Get'}
      modal='Amazon Manual Load Modal'
    />
  );
};
